import { createRouter, createWebHistory } from "vue-router";
import List from '@/views/list.vue'
import Index from '@/views/index.vue'
const routes = [
  {
    path: '/', component: List, name: 'list'
  },
  {
    path: '/index', component: Index, name: 'index'
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes, // short for `routes: routes`
})
router.beforeEach((to, from, next) => {
  if (to.name == 'list') {
    // document.title = '客服'
  }
  next();
})

export default router